export const images = [
    { src: './assets/imgs/nosotros/imgsBanner/1.jpg', alt: 'Image 1' },
    { src: './assets/imgs/nosotros/imgsBanner/2.jpg', alt: 'Image 2' },
    { src: './assets/imgs/nosotros/imgsBanner/3.jpg', alt: 'Image 3' },
];